

export class EventSpecifier{
    constructor(type, targetTest, handler, bubbleup){
        /*
        var _type;
        var _target;
        var _handler; 

        Object.defineProperty(this,'type',{
            set : function(t){ _type = t },
            get : function(){ return _type }
        });
        */

        this.type = type;
        this.targetTest = targetTest;
        this.handler = handler;
        this.bubbleup = bubbleup || false; 
    }

    // =======
    // public 
    // -------
    setBubbleUp(b){ this.bubbleup = b }

    getBubbleUp(){ return this.bubbleup; }

    setType(t){
        this.type = t; 
    }

    getType(){ return this.type }

    setTargetTest(f){
        this.targetTest = f;
    }

    getTargetTest(){ return this.targetTest }

    setHandler(h){
        this.handler = h;
    }

    getHandler(){ return this.handler }

    test(event){
        return ((event.type === this.getType() ) && ( this.targetTest(event.target, event))) 
    }

    runHandler(event){
        if (this.handler) this.handler(event);
    }

    run(event){
        if (this.test(event)){
            if (!this.getBubbleUp()) event.stopPropagation();
            this.runHandler(event);
        } else console.log('event.type/target',event.target, event.type);
    }

}